import React, { useState } from 'react'
import { Row, Col, Card, Modal } from 'react-bootstrap'
import { AlternateEmailOutlined, CallEndOutlined } from '@material-ui/icons'

const AccountContestation = ({ providersList }) => {
	const [data, setData] = useState({});
	const [showModal, setShowModal] = useState(false);

	const logMeinInfo = () => {
		return (<>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Atendimento ao Cliente:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800-878-3155 – Opção 3 Financeiro</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Financeiro:</span></Col>
				<Col md="12"><span className="h5"><AlternateEmailOutlined /> <a href="mailto:jivefinanceiro@logmein.com">jivefinanceiro@logmein.com</a></span></Col>
			</Row>
		</>)
	}

	const net2PhoneInfo = () => {
		return (<>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Atendimento ao Cliente:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800 580 2626</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">SAC:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 10326</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Email - Suporte Administrativo:</span></Col>
				<Col md="12"><span className="h5"><AlternateEmailOutlined /> <a href="mailto:sac@net2phone.com">sac@net2phone.com</a></span></Col>
			</Row>
		</>)
	}

	const equinixInfo = () => {
		return (<>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Atendimento ao Cliente:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800 892 5065 / 11 3958 0325</span></Col>
			</Row>
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">E-Mail:</span></Col>
				<Col md="12"><span className="h5"><AlternateEmailOutlined /> <a href="mailto:support@equinix.com">support@equinix.com</a></span></Col>
			</Row>
		</>)
	}

	const cypressInfo = () => {
		return (
			<Row className="mb-4">
				<Col md="12"><span className="font-weight-bold">Atendimento ao Cliente:</span></Col>
				<Col md="12"><span className="h5"><CallEndOutlined /> 0800 726 8926</span></Col>
			</Row>
		)
	}

	const providers = [
		{
			id: 1,
			modal_size: "lg",
			info: logMeinInfo()
		},
		{
			id: 2,
			modal_size: "",
			info: net2PhoneInfo()
		},
		{
			id: 3,
			modal_size: "",
			info: equinixInfo()
		},
		{
			id: 4,
			modal_size: "",
			info: cypressInfo()
		}
	];

	providersList.forEach((item) => {
		providers.filter(p => p.id == item.id)[0]['name'] = item.name;
		providers.filter(p => p.id == item.id)[0]['logo'] = item.url_image_logo;
	})

	return (<>
		<Row className="mt-4">
			<Col md="12">
				<p style={{ fontStyle: "italic" }}>
					“Caro Parceiro, o suporte administrativo em relação às faturas mensais dos clientes finais é prestado diretamente pelo Provedor de Serviços contratado. 
					Abaixo você poderá selecionar o Provedor de Serviços para obter o número de contato direto com o provedor para o devido atendimento” Em caso de dúvidas 
					por favor entre em contato com <a href="mailto:contatomasteragent@scansource.com">contatomasteragent@scansource.com</a></p>
			</Col>
		</Row>
		<Row className="mt-4">
			{providers.map((p, i) => (
				<Col key={i} md="3" className="pb-3" style={{ height: '220px' }}>
					<Card className="h-100" style={{ cursor: 'pointer' }}
						onClick={async () => {
							await Promise.resolve().then(() => setData(p))
							setShowModal(true)
						}}
					>
						<Card.Body className="h-100 shadow rounded">
							<Row className="h-100">
								<Col className="d-flex align-items-center justify-content-center">
									<img src={`${p.logo}`} className="center w-75" />
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			))}
		</Row>			
		<Modal size={data.modal_size} show={showModal} centered onHide={() => setShowModal(false)}>
			<Modal.Header closeButton>
				<Modal.Title>
					<span>{data.name}</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{data.info ? data.info : null}
			</Modal.Body>
		</Modal>
	</>)
}

export default AccountContestation;